import ExampleCsvAfter from 'img/example_csv_after.png'
import ExampleCsvBefore from 'img/example_csv_before.png'
import ExampleCsvTable from 'img/example_csv_table.png'
import NotSameArticles from 'img/pt_not_same_articles.png'
import SameArticles from 'img/pt_same_articles.png'
import SameArticlesVertical from 'img/pt_same_articles_vertical.png'
import { forwardRef, useImperativeHandle, useState } from 'react'
import { useTranslation } from 'react-i18next'

export interface ExplainPowertoolsProps {
  handleNext: () => void
}

export interface ExplainPowertoolsRef {
  goToNextStep: () => void
}

const ExplainPowertools = forwardRef<ExplainPowertoolsRef, ExplainPowertoolsProps>(
  ({ handleNext }, ref) => {
    const { t } = useTranslation()
    const [currentStep, setCurrentStep] = useState(0)

    /* through the ref I make it so that when I click next while the child is in the first step, then it calls the child's function. 
      instead if I'm in the second step it calls the parent's function
    */
    useImperativeHandle(ref, () => ({
      goToNextStep: () => {
        if (currentStep < 1) {
          setCurrentStep((prev) => prev + 1)
        } else {
          handleNext() // Call the parent when the child has finished its steps
        }
      },
    }))

    const explainConceptOfSameArticles = () => (
      <div className="d-flex flex-column w-100">
        <div className="wizard-content container">
          <h3 className="fw-normal">{t('onboarding.beforeImport')}</h3>
          <p className=" fs-6 fw-light">{t('onboarding.conceptSameArticles')}</p>
        </div>
        <div className="container">
          <div className="pt-3">
            <div className="row">
              <div className="col-xl-6 col-12">
                <div className="d-flex align-items-center flex-column">
                  <img className="card-img d-none d-md-block" src={SameArticles} />
                  <img className="img-fluid w-75 d-md-none" src={SameArticlesVertical} />
                  <h6>{t('onboarding.sameArticles')}</h6>
                  <p className="m-0 p-0 pt-1  fs-6 fw-light">
                    {t('onboarding.sameArticlesReason')}
                  </p>
                </div>
              </div>
              <div className="col-xl-6 col-12 px-xl-5 pt-5 pb-2 py-xxl-0">
                <div className="d-flex align-items-center flex-column">
                  <img className="card-img" src={NotSameArticles} />
                  <h6>{t('onboarding.notSameArticles')}</h6>
                  <p className="m-0 p-0 pt-1  fs-6 fw-light">
                    {t('onboarding.notSameArticlesReason')}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="mt-5">
            <h6 className="fs-6 m-0 p-0">{t('onboarding.sameArticlesNote')}</h6>
            <p className="fs-6 fw-light">{t('onboarding.sameArticlesSpecification')}</p>
          </div>
        </div>
      </div>
    )

    const explainHowPricesAndCommentsWorks = () => (
      <div className="d-flex justify-content-center w-100">
        <div className="wizard-content container">
          <h3 className="fs-3 fw-normal">{t('onboarding.uploadCsvInfo')}</h3>
          <p className=" fs-6 fw-light">{t('onboarding.uploadCsvExplaination')}</p>
          <div className="example-table-container">
            <img src={ExampleCsvTable} className="csv-example-table" />
          </div>
          <div className="p-0 m-0 mt-5">
            <div className="row">
              <div className="col-xxl-6">
                <h6>{t('onboarding.beforeSaving')}</h6>
                <img className="card-img-2 csv-example-img" src={ExampleCsvBefore} />
              </div>
              <div className="col-xxl-6 ">
                <h6>{t('onboarding.afterSaving')}</h6>
                <img className="card-img csv-example-img" src={ExampleCsvAfter} />
              </div>
            </div>
          </div>
        </div>
      </div>
    )

    return (
      <>{currentStep === 0 ? explainConceptOfSameArticles() : explainHowPricesAndCommentsWorks()}</>
    )
  }
)

export default ExplainPowertools
